/**
 * Debounce on trailing edge.
 * Passed callback function is called after n-millisecond delay
 * only once per timeout period after at the end of time period.
 *
 * @param {Function} callback callback function
 * @param {*} timeout timeout
 * @returns {Function} debounced function
 */
const debounce = (callback, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback.apply(this, args);
    }, timeout);
  };
};

export default debounce;
